// import { Spin } from "antd"
import React from "react"
import { useRoutes } from "react-router-dom"
import ROUTER from "./index"
import { BallTriangle } from "react-loader-spinner"
// ANONYMOUS
const PublicRouters = React.lazy(() => import("src/pages/PublicRouters"))
const SvgViewer = React.lazy(() => import("src/pages/SvgViewer"))
const NotFound = React.lazy(() => import("src/pages/NotFound"))
const Home = React.lazy(() => import("src/pages/ANONYMOUS/Home"))
const LoginPage = React.lazy(() => import("src/pages/ANONYMOUS/LoginPage"))
const RegisterPage = React.lazy(() => import("src/pages/ANONYMOUS/Register"))
const InfoAccount = React.lazy(() => import("src/pages/ANONYMOUS/InfoAccount"))
const QrScanner = React.lazy(() => import("src/pages/ANONYMOUS/QrScanner"))

// USER
const PrivateRoutes = React.lazy(() => import("src/pages/PrivateRoutes"))
const ChangePassword = React.lazy(() => import("src/pages/USER/ChangePassword"))

// ADMIN
const AminRoutes = React.lazy(() => import("src/pages/ADMIN/AminRoutes"))
const HomeAdmin = React.lazy(() => import("src/pages/ADMIN/HomeAdmin"))
const BookUse = React.lazy(() => import("src/pages/ADMIN/BookUse"))
const Role = React.lazy(() => import("src/pages/ADMIN/Role"))

function LazyLoadingComponent({ children }) {
  return (
    <React.Suspense
      fallback={
        <div className="loading-center" style={{ height: "100vh" }}>
          {/* <Spin /> */}
          <BallTriangle
            height={50}
            width={50}
            radius={5}
            color="#01638d"
            ariaLabel="ball-triangle-loading"
            wrapperClass={{}}
            wrapperStyle=""
            visible={true}
          />
        </div>
      }
    >
      {children}
    </React.Suspense>
  )
}

const routes = [
  {
    path: ROUTER.SVG_VIEWER,
    element: (
      <LazyLoadingComponent>
        <SvgViewer />
      </LazyLoadingComponent>
    ),
  },
  // ADMIN
  {
    element: (
      <LazyLoadingComponent>
        <AminRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.QUAN_LY_DIEN_TAP,
        element: (
          <LazyLoadingComponent>
            <HomeAdmin />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TIEU_CHI_DANH_GIA,
        element: <LazyLoadingComponent>đánh giá</LazyLoadingComponent>,
      },
      {
        path: ROUTER.DONG_GOP_Y_KIEN,
        element: <LazyLoadingComponent>Đóng góp</LazyLoadingComponent>,
      },
      {
        path: ROUTER.QUAN_LY_TAI_LIEU,
        element: <LazyLoadingComponent>quản lý tài liệu</LazyLoadingComponent>,
      },
      {
        path: ROUTER.QUAN_LY_FORM_MAU,
        element: <LazyLoadingComponent>quản lý form</LazyLoadingComponent>,
      },
      {
        path: ROUTER.DANH_BA_NGUOI_DUNG,
        element: (
          <LazyLoadingComponent>
            <BookUse />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.PHAN_QUYEN,
        element: <LazyLoadingComponent>{/* <Role /> */}</LazyLoadingComponent>,
      },
      {
        path: ROUTER.LICH_SU_HOAT_DONG,
        element: <LazyLoadingComponent>lịch sử</LazyLoadingComponent>,
      },
      {
        path: ROUTER.DASHBOARD,
        element: <LazyLoadingComponent>dashboard</LazyLoadingComponent>,
      },
      {
        path: ROUTER.CHI_TIET,
        element: <LazyLoadingComponent>chi tiết</LazyLoadingComponent>,
      },
    ],
  },
  //  USER
  {
    element: (
      <LazyLoadingComponent>
        <PrivateRoutes />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.DOI_MAT_KHAU,
        element: (
          <LazyLoadingComponent>
            <ChangePassword />
          </LazyLoadingComponent>
        ),
      },
    ],
  },

  //  ANONYMOUS
  {
    element: (
      <LazyLoadingComponent>
        <PublicRouters />
      </LazyLoadingComponent>
    ),
    children: [
      {
        path: ROUTER.HOME,
        element: (
          <LazyLoadingComponent>
            <Home />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_NHAP,
        element: (
          <LazyLoadingComponent>
            <LoginPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.DANG_KY,
        element: (
          <LazyLoadingComponent>
            <RegisterPage />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.ACCOUNT,
        element: (
          <LazyLoadingComponent>
            <InfoAccount />
          </LazyLoadingComponent>
        ),
      },
      {
        path: ROUTER.TIN_TUC,
        element: (
          <LazyLoadingComponent>
            <QrScanner />
          </LazyLoadingComponent>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <LazyLoadingComponent>
        <NotFound />
      </LazyLoadingComponent>
    ),
  },
]
const AppRouter = () => {
  const renderRouter = useRoutes(routes)
  return renderRouter
}
export default AppRouter
